import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { TranslationKeys } from '@nimbus-library/features/localization/models/enums/translation-keys.enum';
import { DutyPresence } from '@nimbus-library/features/user-state/models/user-state';
import { UserTaskStateService } from '@nimbus-library/features/user-state/services/user-task-state.service';
import { ReportingUserSessionsService } from '@nimbus-global/features/reportingLiveData/reporting-user-sessions.service';
import { UserNotReadyReason, UserNotReadyReasonTooltipMapper } from '@nimbus-library/features/user-state/models/not-ready-reason';

@Component({
  standalone: false,
  selector: 'nimbus-availability-state',
  templateUrl: './availability-state.component.html',
  styleUrls: ['./availability-state.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AvailabilityStateComponent implements OnInit {
  public readonly TranslationKeys = TranslationKeys;
  public readonly UserNotReadyReasonTooltipMapper = UserNotReadyReasonTooltipMapper;
  public readonly UserNotReadyReason = UserNotReadyReason;
  public readonly DutyPresence = DutyPresence;

  public userCanGetTasks$ = this.userTaskStateService.canGetTask$();
  public userNotReadyReasonHint$ = this.userTaskStateService.getNotReadyReasonHint$();
  public showAvailabilityState$: Observable<boolean>;

  public constructor(
    private readonly userTaskStateService: UserTaskStateService,
    private readonly reportingUserSessionsService: ReportingUserSessionsService,
  ) {}

  public ngOnInit(): void {
    this.showAvailabilityState$ = combineLatest([
      this.reportingUserSessionsService.getUserSessionLiveInAcw$(),
      this.userTaskStateService.getRonaStartedAt$(),
    ]).pipe(map(([acwSession, ronaStartedAt]) => !acwSession && !ronaStartedAt));
  }
}
